/**
 * @file TradingSetup.jsx
 * @description Main application interface with role-specific features
 * 
 * @section Responsibilities
 * - Manage role-based views
 * - Handle data aggregation
 * - Control real-time updates
 * - Manage user preferences
 * 
 * @section Dependencies
 * - Role Management: Access control
 * - Data Services: Information handling
 * - State Management: Global state
 * 
 * @section Integration Points
 * - Data API: Information retrieval
 * - Role System: Access control
 * - Notification System: Real-time updates
 * 
 * @section State Management
 * - dashboardData: Aggregated information
 * - loadingState: Data fetching
 * - errorState: Error handling
 * 
 * @section Events
 * - onDataUpdate: Data changes
 * - onError: Error handling
 * - onPreferenceChange: Settings updates
 * 
 * @section Props
 * @prop {String} userRole - Current user role
 * @prop {Object} permissions - User permissions
 */

import React, { useState } from "react";
import SkinPage from "../../SkinPage";
import Strategies from "../../widgets/profile/Strategies";
import PortfolioAllocationFull from "../../widgets/portfolio/PortfolioAllocationFull";
import RiskComparison from "../../widgets/profile/RiskComparison";
import Help from "../../widgets/other/Help";
import Restrictions from "../../widgets/portfolio/Restrictions";

function TradingSetup() {
  return (
    <SkinPage>
      <Strategies width={"full-width"} />
      <PortfolioAllocationFull width={"full-width"} />
      <RiskComparison width={"full-width"} />
      <div className="widget-row">
        <div className="widget-column">
          <Restrictions width={"full-width"} />
        </div>
        <div className="widget-column">
          <Help width={"full-width"} />
        </div>
      </div>
    </SkinPage>
  );
}

export default TradingSetup;
